(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/joker/joker-input.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/joker/joker-input.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.joker_input = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<input\n  type=\"tel\"\n  id=\"joker-number\"\n  name=\"joker-number\"\n  class=\"js-joker-input joker-input std-input\"\n  value=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"inputJokerNumbers") || (depth0 != null ? lookupProperty(depth0,"inputJokerNumbers") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"inputJokerNumbers","hash":{},"data":data,"loc":{"start":{"line":6,"column":9},"end":{"line":6,"column":30}}}) : helper)))
    + "\"\n  pattern=\"[0-9]{7}\"\n  maxlength=\"7\"\n/>\n<div id=\"jokerInputErrorRegion\"></div>";
},"useData":true});
Handlebars.partials['components-numbergames-game-joker_input'] = svs.numbergames.game.templates.joker_input;
})(svs, Handlebars);


 })(window);